
import { toJS } from "mobx";
import * as APITypes from "constants/API";
import axios from "axios";

import getCookie from "utils/journeyIdCookie/getJourneyId";
import AuthStore from "../../../../../src/modules/login/store/AuthStore";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
const selectedProduct = async (data) => {
    let risk = data.selectedRisk

    let bi_data = { family_product_id: data.family_product_id, risk_type: risk, ...data.bi_request };
    // let requestObj = {
    //     journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    //     family_product_id: data.family_product_id,
    //     risk_type: risk,
    //     recommended_products: {
    //         [risk]: {
    //             planName: data.product_name,
    //             productId: data.product_id,
    //             packageId: data.package_id,
    //             recommended_sa: data.recommended_sum_assured,
    //             revised_sa: data.recommended_sum_assured
    //         }
    //     }
    // }


    let response = await axios.post(APITypes.GET_RECO_FROM_FRONTEND_BI, bi_data);

    return response.status
}
export default selectedProduct